export function resolveMaasImageStoragePaths(_prefix: string): Record<string, string> {
  return {};
}
